import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { Table,Modal,Input,Button,Icon,Row,Col,Select,Radio,Form,message,Tabs,Tooltip,Popconfirm } from 'antd';
import App from '../../App';
import getUserServiceMapping from '../../queries/getUserServiceMapping'
import createUserServiceMapping from '../../mutation/createUserServiceMapping'
import deleteUserServiceMapping from '../../mutation/deleteUserServiceMapping'
import getPlatformServicesByPlatform from '../../queries/getPlatformServicesByPlatform'
import getSubscriptionPlansBySiteId from '../../queries/getSubscriptionPlansBySiteId'
import {returnSymbol} from '../../utils/returnSymbol'
import { country } from '../../utils/countryCurrency';
const { Option } = Select;
const FormItem = Form.Item;
const { TabPane } = Tabs;
const { TextArea } = Input;
const type = [
    { key: '1', value: 'SIMPLE_B2C', label: 'e-Commerce' },
    { key: '2', value: 'MARKETING', label: 'Marketing Site' },
    { key: '7', value: 'B2C_MARKET_PLACE', label: 'B2C Market Place' },
    { key: '9', value: 'O2OCommerce', label: 'O2O Commerce' }
]
var PLATFORM = [
    // { value: 'ENQUIRY', label: 'Enquiry' },
    { value: 'BOOKING_RESTAURANTS', label: 'Restaurant' },
    { value: 'BOOKING_SALOON', label: 'Saloon' },
    // { value: 'BOOKING_ENQUIRY', label: 'Enquiry' },
    // { value: 'BOOKING_LAB', label: 'Diagnostic Lab' },
    { value: 'BOOKING_VACCINATION', label: 'Vaccination Program' },
    { value: 'LAUNDRY', label: 'Laundry' },
    { value: 'EVENT', label: 'Event' },
    { value: 'VILLA_RENTAL', label: 'Vill Rental' },
    { value: 'SERVICES', label: 'Services' },
    { value: 'CAR_RENTAL', label: 'Car Rental' },
    { value: 'CONSTRUCTION', label: 'Construction' },
    { value: 'GROCERY', label: 'Grocery' },
    { value: 'GENERAL', label: 'General' },
    { value: 'LAWYER', label: 'Lawyer' },
    { value: 'PET_GROOMERS', label: 'Pet Groomers' },
    { value: 'REPAIR_SERVICES', label: 'Repair Services' },
    { value: 'SPA', label: 'Spa' },
    { value: 'GYM', label: 'Gym' },
    { value: 'MANUFACTURER', label: 'Manufacturer' },
    { value: 'JEWELLERY', label: 'Jewellery' },
    { value: 'MARRIAGE', label: 'Marriage' },
    { value: 'AUTO_SERVICES', label: 'Auto Services' },
    { value: 'DIAGNOSTIC_LAB', label: 'Diagnostic Lab' },
    { value: 'DOCTOR', label: 'Doctor' },
    { value: 'VACATION_RENTALS', label: 'Vacation Rentals' },
    { value: 'GRANITE_BUSINESS', label: 'Granite Business' },
    { value: 'WAREHOUSE', label: 'Warehouse' },
    { value: 'DEPARTMENT', label: 'Department' },
]
class CPServices extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cpServiceDataPlan: [],
            cpServiceDataAddon: [],
            allcpService: [],
            addons: [],
            allPlan: [],
            loading: false,
            showAddServiceModal: false,
            value: 'PLAN',
            tabKey: 'PLAN',
            submitLoading: false,
            selectedPlan: null,
            editingKey: null,
            editValues:{}
        }
    }
    componentDidMount() {
        this.getCpServices()
    }
    getCpServices = () => {
        this.setState({ loading: true });
        this.props.client
            .query({
                query: getUserServiceMapping,
                variables: { userId: this.props.location.state && this.props.location.state.cpData && this.props.location.state.cpData.username ? this.props.location.state.cpData.username : null },
                fetchPolicy: 'no-cache',
            })
            .then(({ data }) => {
                let filterData = data.getUserServiceMapping;
                const addons = filterData.filter(item => item.type === "ADDONS");
                const plans = filterData.filter(item => item.type === "PLAN");
                this.setState({ cpServiceDataPlan: plans,cpServiceDataAddon:addons,allcpService:filterData,loading: false, });
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({ loading: false });
            });
    }
    addServiceModal = () => {
        // this.getMasterPlan()
        this.setState({
            showAddServiceModal: true
        })
    }
    onChange = (e) => {
        console.log("value", e.target.value)
        this.setState({
            value: e.target.value
        })
    }
    handleCancel = () => {
        this.setState({
            showAddServiceModal: false
        })
    }
    handleSelectChange = (value) => {
        console.log("value ::", value)
        if (value == 'SIMPLE_B2C') {
            PLATFORM = [
                { value: 'COMMERCE', label: 'e-Commerce' },
                { value: 'ENQUIRY', label: 'Enquiry' },
                { value: 'ECOM_CATALOGUE', label: 'Catalogue' },
                // { value: 'ECOM_CATALOGUE', label: 'Catalogue' },
            ]
        } else if (value == 'MARKETING') {
            PLATFORM = [
                { value: 'GENERAL', label: 'General' }
            ]
        } else if (value == 'B2C_MARKET_PLACE') {
            PLATFORM = [
                { value: 'B2B', label: 'B2C Marketplace' },
                { value: 'B2B2C', label: 'B2B Marketplace' },
                { value: 'ENQUIRY', label: 'Enquiry Marketplace' },

            ]
        } else {
            PLATFORM = [
                // { value: 'ENQUIRY', label: 'Enquiry' },
                { value: 'BOOKING_RESTAURANTS', label: 'Restaurant' },
                { value: 'BOOKING_SALOON', label: 'Saloon' },
                // { value: 'BOOKING_ENQUIRY', label: 'Enquiry' },
                // { value: 'BOOKING_LAB', label: 'Diagnostic Lab' },
                { value: 'BOOKING_VACCINATION', label: 'Vaccination Program' },
                { value: 'LAUNDRY', label: 'Laundry' },
                { value: 'EVENT', label: 'Event' },
                { value: 'VILLA_RENTAL', label: 'Vill Rental' },
                { value: 'SERVICES', label: 'Services' },
                { value: 'CAR_RENTAL', label: 'Car Rental' },
                { value: 'CONSTRUCTION', label: 'Construction' },
                { value: 'GROCERY', label: 'Grocery' },
                { value: 'GENERAL', label: 'General' },
                { value: 'LAWYER', label: 'Lawyer' },
                { value: 'PET_GROOMERS', label: 'Pet Groomers' },
                { value: 'REPAIR_SERVICES', label: 'Repair Services' },
                { value: 'SPA', label: 'Spa' },
                { value: 'GYM', label: 'Gym' },
                { value: 'MANUFACTURER', label: 'Manufacturer' },
                { value: 'JEWELLERY', label: 'Jewellery' },
                { value: 'MARRIAGE', label: 'Marriage' },
                { value: 'AUTO_SERVICES', label: 'Auto Services' },
                { value: 'DIAGNOSTIC_LAB', label: 'Diagnostic Lab' },
                { value: 'DOCTOR', label: 'Doctor' },
                { value: 'VACATION_RENTALS', label: 'Vacation Rentals' },
                { value: 'GRANITE_BUSINESS', label: 'Granite Business' },
                { value: 'WAREHOUSE', label: 'Warehouse' },
                { value: 'DEPARTMENT', label: 'Department' },
            ]
        }
    }
    getPlatformServices = (value) => {
        if(this.state.value == 'PLAN'){
            console.log("value",value)
            this.setState({
                selectedPlan: null,
            })
            this.getMasterPlan(value)

        }else{
        this.props.client
            .query({
                query: getPlatformServicesByPlatform,
                variables: { siteId: 'master', platform: value },
                fetchPolicy: 'no-cache',
            })
            .then(({ data }) => {
                let filterData = data.getPlatformServicesByPlatform;
                console.log("filterData", filterData)
                let fData = filterData.sort((a, b) => a.serviceName.localeCompare(b.serviceName))
                this.setState({ addons: fData, loading: false });
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({ loading: false });
            });
        }
    }
    getMasterPlan = (platform) => {
        this.props.client.query({
            query: getSubscriptionPlansBySiteId,
            variables: {
                siteId: 'master',
            },
            fetchPolicy: 'network-only',
        })
            .then(({ data }) => {
                // console.log("getSubscriptionPlansBySiteId ::",data)
                if (data && data.getSubscriptionPlansBySiteId) {
                    let allPlan = data.getSubscriptionPlansBySiteId
                    // let platform = 'BOOKING_RESTAURANTS'
                    let sort = allPlan.filter(function (hero) {
                        return (platform ? (hero.siteType == 'O2OCommerce' && hero.platform == platform) : hero.siteType == 'O2OCommerce')
                    })
                    let fData = sort.sort((a, b) => a.planName.localeCompare(b.planName))
                    this.setState({
                        allPlan: fData
                    })

                }
            })
    }
    onPlanChange=(value)=>{
        console.log("onPlanChange",value)
        let plan = this.state.allPlan.find((x)=>x.planId == value)
        console.log("plan",plan)
        this.setState({
            selectedPlan: plan
        })
    }
    handleSubmit = () => {
        this.props.form.validateFields((err, values) => {
            console.log("values",values)
            this.setState({
                submitLoading: true
            })
            if(!err){
                console.log("values",values)
                let serName=''
                if(this.state.value == 'PLAN'){
                    let allPlan = this.state.allPlan
                    let index = allPlan.findIndex((x)=>x.planId == values.sitePlan)
                    serName = allPlan[index].planName
                }else{
                    let allPlan = this.state.addons
                    let index = allPlan.findIndex((x)=>x.serviceId == values.addon)
                    serName = allPlan[index].serviceName
                }
                let variable = {
                        siteId: "master",
                        serviceId: this.state.value == 'PLAN' ? values.sitePlan : values.addon,
                        userId: this.props.location.state.cpData.username,
                        type: this.state.value,
                        boardingAmount: parseFloat(values.boardingAmount * 100),
                        renewalAmount: parseFloat(values.renewalAmount * 100),
                        siteOptions: this.state.value == 'PLAN' ? this.state.selectedPlan.platform : values.siteOption,
                        note: values.note,
                        serviceName: serName
                }
                this.props.client.mutate({
                    mutation: createUserServiceMapping,
                    variables: variable
                }).then(({ data }) => {
                    console.log("Resp Charges ::", data)
                    message.success("Service Map Successfully");
                    this.props.form.resetFields();
                    let plans = this.state.cpServiceDataPlan
                    let addons = this.state.cpServiceDataAddon
                    if(this.state.value == 'PLAN'){
                        plans.push(variable)
                    }else{
                        addons.push(variable)
                    }
                    this.setState({
                        submitLoading: false,
                        cpServiceDataPlan: plans,
                        cpServiceDataAddon: addons
                    })
                })
            }else{
                this.setState({
                    submitLoading: false
                })
            }
        })
    }
    onTabChange=(value)=>{
        console.log("onTabChange",value)
        this.setState({
            tabKey: value
        })
    }
    handleServiceDelete=(record)=>{
        this.props.client.mutate({
            mutation: deleteUserServiceMapping,
            variables: {
                serviceId: record.serviceId,
                userId: this.props.location.state.cpData.username,
            }
        }).then(({ data }) => {
            console.log("Resp Charges ::", data)
            message.success("Service Delete Successfully");
        })
    }
    isEditing = (record) => record.id === this.state.editingKey;
     handleEdit = (record) => {
        console.log("handleEdit",record)
        let obj={
            annual: record.boardingAmount / 100,
            renewal: record.renewalAmount / 100
        }
        this.setState({
            editingKey:record.id,
            editValues: obj
        })
       
    }
    handleSave=(id)=>{
        console.log("handleSave",id)
        const newData = this.state.cpServiceDataPlan.map(item => 
            item.id === id ? { ...item, boardingAmount: this.state.editValues.annual * 100, renewalAmount: this.state.editValues.renewal * 100 } : item
        );
        console.log("handleSave",newData)
        this.setState({
            editingKey: null
        })
    }
    handleCancelSave=()=>{
        this.setState({
            editingKey: null,
            editValues:{}
        })
    }
    handleChangeAnnual=(e)=>{
        let currentValue = this.state.editValues
        console.log("currentValue",currentValue)
        currentValue.annual = e.target.value
        this.setState({
            editValues: currentValue
        })
        
    }
    handleChangeRenewal=(e)=>{
        let currentValue = this.state.editValues
        currentValue.renewal = e.target.value
        this.setState({
            editValues: currentValue
        })
    }
    render() {
        console.log("props",this.props)
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const cpData = this.props.location.state && this.props.location.state.cpData ? this.props.location.state.cpData : null
        let countryName = country.find((code)=>code.value == (cpData && cpData.address && cpData.address.country ? cpData.address.country : ''))
        const columns=[
            { title: 'Service Name', dataIndex: 'serviceName',width: '25%'},
            { title: 'Site Option', dataIndex: 'siteOptions',width: '15%'},
            {
                title: 'Annual',
                width: '15%',
                render: (record) => (
                    this.isEditing(record) ? (
                        <Input value={this.state.editValues && this.state.editValues.annual} onChange={(e) => this.handleChangeAnnual(e)} />
                    ) : (
                        <span>{returnSymbol(parseFloat(record.boardingAmount / 100), cpData.currency ? cpData.currency : 'INR')}</span>
                    )
                )
            },
            {
                title: 'Renewal',
                width: '15%',
                render: (record) => (
                    this.isEditing(record) ? (
                        <Input value={this.state.editValues && this.state.editValues.renewal} onChange={(e) => this.handleChangeRenewal(e)} />
                    ) : (
                        <span>{returnSymbol(parseFloat(record.renewalAmount / 100), cpData.currency ? cpData.currency : 'INR')}</span>
                    )
                )
            },
            { title: 'Note',dataIndex: 'note',width: '20%'},
            { 
                title: 'Action',
                width: '10%',
                render:(data)=>{
                    return(
                        <>
                        {this.isEditing(data) ? 
                        <>
                        <Tooltip title="Save">
                            <Button 
                                icon="save" 
                                onClick={() => this.handleSave(data.id)} 
                                type="default" style={{ cursor: "pointer", background: "#389e0d", color: "#fff",marginRight: 10 }}
                            />
                        </Tooltip>
                        <Tooltip title="Cancel">
                            <Button 
                                icon="close" 
                                onClick={() => this.handleCancelSave(data.id)} 
                                type="default" style={{ cursor: "pointer", background: "#389e0d", color: "#fff",marginRight: 10 }}
                            />
                        </Tooltip>
                        </>
                         : 
                         <>
                            {/* <Tooltip title="Edit">
                                <Button 
                                    icon="edit"
                                    onClick={() => this.handleEdit(data)} 
                                />
                            </Tooltip> */}
                            <Tooltip placement="top" title="Delete">
                                <Popconfirm title="Sure to delete?" onConfirm={() => this.handleServiceDelete(data)}>
                                    <Button
                                        icon="delete"
                                        type="danger"
                                        style={{
                                            marginLeft: "5px",
                                            cursor: "pointer",
                                            background: "#ff0000 ",
                                            color: "#fff",
                                        }}
                                    />
                                </Popconfirm>
                            </Tooltip>
                            </>
                        }
                            
                        </>
                    )
                }
            },
        ]
        return (
            <App header={'Plans / Addons Mapping'}>
                <div className='planCardSection' style={{marginBottom: '10px'}}>
                <p class='planCardSectionText'>CP Profile</p>
                <Row gutter={24}>
                    <Col md={20}>
                    <span style={{fontWeight: 500,color: 'black'}}>Company Name : {cpData.companyName}</span><br></br>
                    <span style={{fontWeight: 500,color: 'black'}}>Contact Person: {cpData.name}</span><br></br>
                    <span style={{fontWeight: 500,color: 'black'}}>Mobile: {cpData.mobile}</span><br></br>
                    <span style={{fontWeight: 500,color: 'black'}}>Address: {cpData.address && cpData.address.city ? `${cpData.address.city} ${cpData.address.state} ${countryName && countryName.label ? countryName.label : cpData.address.country}` : ''}</span><br></br>
                </Col>
                <Col md={4} style={{textAlign: 'end'}}>
                    <span style={{fontWeight: 700,marginRight: '5px',color: 'black'}}>Wallet Balance: {returnSymbol(parseFloat(cpData.balance/100),cpData.currency && cpData.currency ? cpData.currency : 'INR' )}</span>
                    </Col>
                </Row>
                </div>
                <div style={{ textAlign: 'end' }}>
                    {(this.props && this.props.userData && this.props.userData.userRole == 'SITE_CREATOR' || this.props.userData.userRole =='ADMIN') &&(
                    <Button type="primary" onClick={this.addServiceModal} style={{ background: "#389e0d", color: "#fff", marginBottom: '10px' }} >
                        ADD SERVICE
                    </Button>
                    )}
                </div>
                <Tabs onChange={this.onTabChange} type="card">
                <TabPane tab="PLANS" key="PLANS">
                 <Table 
                 size="middle" 
                 columns={columns} 
                 loading={this.state.loading}
                 dataSource={this.state.cpServiceDataPlan} 
                 />
                 </TabPane>
                 <TabPane tab="ADDONS" key="ADDONS">
                 <Table 
                 size="middle" 
                 columns={columns} 
                 loading={this.state.loading}
                 dataSource={this.state.cpServiceDataAddon} 
                 />
                 </TabPane>
                 </Tabs>
                <Modal title="Plans / Addons Mapping" visible={this.state.showAddServiceModal} footer={null} width={500} onCancel={this.handleCancel} destroyOnClose>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: '10px' }}>
                        <Radio.Group onChange={this.onChange} value={this.state.value}>
                            <Radio value={'PLAN'}>Plan</Radio>
                            <Radio value={'ADDONS'}>Addons</Radio>

                        </Radio.Group>
                        {this.state.value == 'PLAN' ?
                        <>
                        <FormItem label='Select Site Option' style={{marginBottom: '0px',lineHeight: '30px'}}>
                                        {getFieldDecorator('siteOption', {
                                            rules: [{
                                                required: true,
                                                message: "Please Select Site Option",
                                            }],
                                        })(
                                            <Select
                                                optionFilterProp="children"
                                                style={{ width: '100%' }}
                                                showSearch
                                                onChange={this.getPlatformServices}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                placeholder="Please Select Site Option">
                                                {PLATFORM.map((c) => {
                                                    return (
                                                        <Select.Option key={c.value} value={c.value} >{c.label}</Select.Option>
                                                    )
                                                })}
                                            </Select>
                                        )}
                                    </FormItem>
                                <FormItem label='Select Site Plan' style={{marginBottom: '0px',lineHeight: '30px',lineHeight: '30px'}}>
                                    {getFieldDecorator('sitePlan', {
                                        rules: [{
                                            required: true,
                                            message: "Please Select Site Option",
                                        }],
                                    })(
                                        <Select
                                            optionFilterProp="children"
                                            style={{ width: '100%' }}
                                            onChange={this.onPlanChange}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            showSearch
                                            placeholder="Please Select Plan">
                                            {this.state.allPlan.map((c) => {
                                                return (
                                                    <Select.Option key={c.serviceId} value={c.planId} >{c.planName}</Select.Option>
                                                )
                                            })}
                                        </Select>
                                    )}
                                </FormItem>
                                
                            </>
                            :
                            <>
                                < >
                                    <FormItem label='Select Site Type' style={{marginBottom: '0px',lineHeight: '30px'}} >
                                        {getFieldDecorator('siteType', {
                                            initialValue: 'O2OCommerce',
                                            rules: [{
                                                required: false,
                                                message: "Please Select Site Option",
                                            }],
                                        })(
                                            <Select
                                                optionFilterProp="children"
                                                style={{ width: '100%' }}
                                                onChange={this.handleSelectChange}
                                                disabled
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                placeholder="Please select">
                                                {type.map((c) => {
                                                    return (
                                                        <Select.Option key={c.planId} value={c.planId} >{c.label}</Select.Option>
                                                    )
                                                })}
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem label='Select Site Option' style={{marginBottom: '0px',lineHeight: '30px'}}>
                                        {getFieldDecorator('siteOption', {
                                            rules: [{
                                                required: true,
                                                message: "Please Select Site Option",
                                            }],
                                        })(
                                            <Select
                                                optionFilterProp="children"
                                                style={{ width: '100%' }}
                                                onChange={this.getPlatformServices}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                showSearch
                                                placeholder="Please Select Site Option">
                                                {PLATFORM.map((c) => {
                                                    return (
                                                        <Select.Option key={c.value} value={c.value} >{c.label}</Select.Option>
                                                    )
                                                })}
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem label='Select Site Addon' style={{marginBottom: '0px',lineHeight: '30px'}}>
                                        {getFieldDecorator('addon', {
                                            rules: [{
                                                required: true,
                                                message: "Please Select Addon Service",
                                            }],
                                        })(
                                            <Select
                                                optionFilterProp="children"
                                                style={{ width: '100%' }}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                showSearch
                                                placeholder="Please Select Addon">
                                                {this.state.addons.map((c) => {
                                                    return (
                                                        <Select.Option key={c.serviceId} value={c.serviceId} >{c.serviceName}</Select.Option>
                                                    )
                                                })}
                                            </Select>
                                        )}
                                    </FormItem>
                                </>
                            </>
                        }
                                    <FormItem label='Annual Amount' style={{marginBottom: '0px',lineHeight: '30px'}}>
                                        {getFieldDecorator('boardingAmount', {
                                            rules: [{
                                                required: true,
                                                message: "Please enter Annual Amount",
                                            }],
                                        })(
                                            <Input />
                                        )}
                                    </FormItem>
                                    <FormItem label='Renewal Amount' style={{marginBottom: '0px',lineHeight: '30px'}}>
                                        {getFieldDecorator('renewalAmount', {
                                            rules: [{
                                                required: true,
                                                message: "Please enter Renewal Amount",
                                            }],
                                        })(
                                            <Input />
                                        )}
                                    </FormItem>
                                    <FormItem label='Note' style={{marginBottom: '0px',lineHeight: '30px'}}>
                                        {getFieldDecorator('note', {
                                            rules: [{
                                                required: false,
                                                message: "Please enter Note",
                                            }],
                                        })(
                                            <TextArea  rows={4}/>
                                        )}
                                    </FormItem>
                                <Row gutter={16} style={{marginTop: '20px'}}>
                                    <Col span={24}>
                                        <Button type="primary" onClick={(e)=>this.handleSubmit()} style={{ background: "#389e0d", color: "#fff", marginBottom: "5%", marginRight: "20px" }} >
                                            SUBMIT
                                        </Button>
                                        <Button type="default" onClick={this.handleCancel} style={{ background: "#f44336", color: "#fff", marginBottom: "5%" }} >CANCEL</Button>
                                    </Col>
                                </Row>
                    </Form>
                </Modal>
            </App>
        );
    }
}
const WrappedCPServices = Form.create({ name: "service_map" })(
    CPServices
);
export default withApollo(WrappedCPServices);